import Vue from "vue";

window.aiDemo = {
    enable:  () => { localStorage.setItem("stratavault.aiDemo", "1"); location.reload(); },
    disable: () => { localStorage.removeItem("stratavault.aiDemo"); location.reload(); },
    status:  () => localStorage.getItem("stratavault.aiDemo") === "1" ? "on" : "off",
};

Vue.component("ai-chat", require("./components/AiChat.vue").default);

require("./app");
